import * as yup from 'yup'

export class AddressDto {
  addressGuid?: string = undefined
  addressNickname?: string = undefined
  address1?: string = ''
  address2?: string = undefined
  city?: string = ''
  county?: string = undefined
  state?: string = '' // TODO: Remove. Use stateProvince instead.
  stateProvince?: string = undefined
  postalCode?: string = ''
  country?: string = ''
  isActive?: boolean = true
}

export const addressValidationSchema = yup.object({
  addressType: yup.object().required('Field is required.'),
  address1: yup.string().max(200, 'Cannot be more than 200 characters.').required('Field is required.'),
  address2: yup.string().max(200, 'Cannot be more than 200 characters.').nullable(),
  address3: yup.string().max(200, 'Cannot be more than 200 characters.').nullable(),
  city: yup.string().max(200, 'Cannot be more than 200 characters.').required('Field is required.'),
  state: yup.string().max(200, 'Cannot be more than 200 characters.').required('Field is required.'),
  postalCode: yup.string().max(200, 'Cannot be more than 200 characters.').required('Field is required.'),
  country: yup.string().max(200, 'Cannot be more than 200 characters.').required('Field is required.'),
  email: yup.string().max(200, 'Cannot be more than 200 characters.').nullable(),
  phone: yup.string().max(200, 'Cannot be more than 200 characters.').nullable(),
  notes: yup.string().max(200, 'Cannot be more than 200 characters.').nullable(),
  isActive: yup.boolean()
})
